import { intervalToDuration } from 'date-fns'

export default function (start: string, end: string) {
  const duration = intervalToDuration({ start, end })
  const hours = duration.hours === undefined ? '' : `${duration.hours}`
  const minutes = duration.minutes === undefined ? '00' : `${duration.minutes}`.padStart(2, '0')
  const seconds = duration.seconds === undefined ? '00' : `${duration.seconds}`.padStart(2, '0')
  return `${hours.length ? hours + ':' : ''}${minutes}:${seconds}`
}
